<div class="wrapper mt-[40px]">
  <div class="workflow-list">
    @if (timelineSteps?.length > 0) {
      @for (step of timelineSteps; track step) {
        <div class="time-block">
          <div class="label-container flex flex-row gap-[12px] mb-[7px]">
            <div class="icon-container correct flex justify-center items-center">
              <mat-icon [svgIcon]="'check'" class="workflow-icon" />
            </div>
            <div [ngClass]="step.status" class="timeline-label">{{ step?.state?.comment }}:</div>
          </div>
          <div class="details">
            <div class="user flex flex-row gap-[8px] mb-[16px]">
              <div class="user-avatar">
                {{ step?.actor?.first_name?.charAt(0) }}
              </div>
              <div class="user-details flex flex-col">
                <div class="user-name">
                  {{ step?.actorName }}
                </div>
                <div class="user-email">
                  {{ step?.actor?.email }}
                </div>
              </div>
            </div>
            @if (step?.input?.formValues?.final_response) {
              <div class="mt-[20px]">
                <div class="timeline-sub-heading">Final Response:</div>
                <div class="comment">
                  @if (shouldTruncateComment(step?.input?.formValues?.final_response)) {
                    @if (!isFinalResponseExpanded(step?.created_at)) {
                      <span>
                        {{ getTruncatedComment(step?.input?.formValues?.final_response) }}
                      </span>
                    }
                    @if (isFinalResponseExpanded(step?.created_at)) {
                      <span>
                        {{ step?.input?.formValues?.final_response }}
                      </span>
                    }
                    <span (click)="toggleFinalResponse(step?.created_at)" class="show-more-less-link cursor-pointer">
                      {{ isFinalResponseExpanded(step?.created_at) ? ' Show less' : ' Show more' }}
                    </span>
                  }
                  @if (!shouldTruncateComment(step?.input?.formValues?.final_response)) {
                    {{ step?.input?.formValues?.final_response }}
                  }
                </div>
              </div>
            }
            @if (step?.input?.formValues?.comments) {
              <div class="mt-[20px]">
                <div class="timeline-sub-heading">Comment:</div>
                <div class="comment">
                  @if (shouldTruncateComment(step?.input?.formValues?.comments)) {
                    @if (!isCommentExpanded(step?.created_at)) {
                      <span>
                        {{ getTruncatedComment(step?.input?.formValues?.comments) }}
                      </span>
                    }
                    @if (isCommentExpanded(step?.created_at)) {
                      <span>
                        {{ step?.input?.formValues?.comments }}
                      </span>
                    }
                    <span (click)="toggleComment(step?.created_at)" class="show-more-less-link cursor-pointer">
                      {{ isCommentExpanded(step?.created_at) ? ' Show less' : ' Show more' }}
                    </span>
                  }
                  @if (!shouldTruncateComment(step?.input?.formValues?.comments)) {
                    {{ step?.input?.formValues?.comments }}
                  }
                </div>
              </div>
            }
            @if (step?.fyi_users && step?.fyi_users?.length) {
              <div class="mt-[20px]">
                <div class="timeline-sub-heading">
                  {{ step?.fyi_users.length > 1 ? 'fyi users:' : 'fyi user:' }}
                </div>
                @for (user of step?.fyi_users; track user) {
                  <div class="user flex flex-row items-center gap-[8px] mb-[10px]">
                    <div class="avatar">
                      {{ user?.first_name?.charAt(0) }}
                    </div>
                    <div class="user-details flex flex-col">
                      <div class="avatar-name">{{ user.first_name }} {{ user.last_name }}</div>
                    </div>
                  </div>
                }
              </div>
            }
            @if (step?.reviewers && step?.reviewers?.length) {
              <div class="mt-[20px]">
                <div class="timeline-sub-heading">
                  {{ step?.reviewers.length > 1 ? 'reviewers:' : 'reviewer:' }}
                </div>
                @for (user of step?.reviewers; track user) {
                  <div class="user flex flex-row items-center gap-[8px] mb-[10px]">
                    <div class="avatar">
                      {{ user?.first_name?.charAt(0) }}
                    </div>
                    <div class="user-details flex flex-col">
                      <div class="avatar-name">{{ user.first_name }} {{ user.last_name }}</div>
                    </div>
                  </div>
                }
              </div>
            }
            @if (step?.attachments?.length) {
              <div class="my-[20px]">
                <div class="pictures-row flex flex-wrap gap-[20px]">
                  @for (attachment of step?.attachments; track attachment) {
                    <div class="picture-block">
                      @if (attachment?.thumb_url) {
                        <app-image
                          (click)="appService.openCarousel($event, step?.attachments, attachment, false)"
                          [url]="attachment.thumb_url"
                          class="each-picture"
                          />
                      } @else {
                        <div
                          (click)="appService.openCarousel($event, step?.attachments, attachment, false)"
                          class="each-document"
                          >
                          <span class="file-title">
                            {{ attachment?.original_name || 'Attachment' }}
                          </span>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
            <div
              [ngClass]="{
                'h-[55px]': !step?.input?.formValues?.signature,
                'mb-[8px] h-[12px]': step?.input?.formValues?.signature
              }"
              class="created-at-container"
              >
              <div class="created-at flex flex-row justify-start items-center gap-[8px]">
                <div>
                  {{ formatInProjectTimezone(step?.created_at, 'MMMM D, YYYY') }}
                </div>
                <div>&#x25CF;</div>
                <div>
                  {{ formatInProjectTimezone(step?.created_at, 'hh:mm A') }}
                </div>
              </div>
            </div>
            @if (step?.input?.formValues?.signature) {
              <div class="signature-container h-[55px] mb-[8px]">
                <div class="signature">
                  {{ step?.input?.formValues?.signature }}
                </div>
              </div>
            }
          </div>
        </div>
      }
    } @else {
      <div class="no-data flex flex-col justify-center items-center gap-[20px]">
        <div class="no-data-text text-center text-type-14">No logs available.</div>
      </div>
    }
  </div>
</div>
